/** Nombre de archivo ASCII seguro (sin tildes ni espacios), máximo 60 caracteres. */
export function fileSlug(value: string, fallback = 'documento'): string {
  const slug = String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);
  return slug || fallback;
}
